exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-orange[data-v-7520e9a1] {\n    color: #ef871d;\n}\n.break-protect[data-v-7520e9a1] {\n    page-break-inside: avoid;\n}\n.body[data-v-7520e9a1] {\n    margin: 25mm;\n}\n@page {\n    margin-top: 1in;\n    margin-bottom: 1in;\n}\n", ""]);

// exports
